var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticStyle: { margin: "0 10%" },
      attrs: {
        row: "",
        "justify-center": "",
        "align-center": "",
        "fill-height": ""
      }
    },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "", sm12: "", md12: "", "order-md1": "" } },
        [
          _c("div", { staticClass: "vv-heading text-xs-center text-md-left" }, [
            _vm._v(_vm._s(_vm.title))
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "vv-subheading  text-xs-center text-md-left" },
            [_vm._v("\n            " + _vm._s(_vm.subtitle) + "\n            ")]
          ),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "vv-subheading  text-xs-center text-md-left" },
            [_vm._v("\n            " + _vm._s(_vm.end) + "\n          ")]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-420621cc", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-420621cc","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/FAQ.vue
// module id = null
// module chunks = 